// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILabelSchema {
  /** Текст **/
  text: string;
  /** Тип метки **/
  type: EType;
}

export enum EType {
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Скидки **/
  'Discount' = 'discount',
  /** Рассрочка **/
  'Installment' = 'installment',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
  /** Количество ЖК **/
  'NewbuildingCount' = 'newbuildingCount',
  /** Без переплат **/
  'NoOverpayments' = 'noOverpayments',
  /** Sale (ЧП) **/
  'Sale' = 'sale',
}
